import {
  SelectInput,
  ReferenceInput,
  PasswordInput,
  TextInput,
} from "react-admin";
import { useTranslate } from "react-admin";

import { InputGuesser } from "@api-platform/admin";

const reportChoices = [
  {
    id: "PDF",
    name: "PDF",
    value: "PDF",
  },
  {
    id: "IMAGE",
    name: "Multiple frames image",
    value: "IMAGE",
  },
  {
    id: "SINGLE_IMAGE",
    name: "Single image",
    value: "SINGLE_IMAGE",
  },
  {
    id: "MULTIPLE_IMAGE_FILES",
    name: "Multiple images",
    value: "MULTIPLE_IMAGE_FILES",
  },
];

const structuredDataChoices = [
  {
    id: "SR",
    name: "Structured reports",
    value: "SR",
  },
];
const maskChoices = [
  {
    id: "SEGMENTATION",
    name: "Segmentation",
    value: "SEGMENTATION",
  },
  {
    id: "FUSED_IMAGE",
    name: "Fused images",
    value: "FUSED_IMAGE",
  },
];
const meshChoices = [
  {
    id: "OBJ",
    name: "3d OBJ format",
    value: "OBJ",
  },
];
const registeredVolumeChoices = [
  {
    id: "MULTIPLE_IMAGE_FILES",
    name: "Multiple images",
    value: "MULTIPLE_IMAGE_FILES",
  },
  {
    id: "ENHANCED",
    name: "Single file with all slices",
    value: "ENHANCED",
  },
];
const compressionChoices = [
  {
    id: "JPEGBaseline8Bit",
    name: "JPEG Lossy",
    value: "JPEGBaseline8Bit",
  },
  {
    id: "JPEGLosslessSV1",
    name: "JPEG Lossless",
    value: "JPEGLosslessSV1",
  },
  {
    id: "JPEGLSLossless",
    name: "JPEG LS Lossless",
    value: "JPEGLSLossless",
  },
  {
    id: "JPEG2000",
    name: "JPEG2000 Lossy",
    value: "JPEG2000",
  },
  {
    id: "JPEG2000Lossless",
    name: "JPEG2000 Lossless",
    value: "JPEG2000Lossless",
  },
  {
    id: "RLELossless",
    name: "RLE Lossless",
    value: "RLELossless",
  },
];

export const DicomNodeGroupField = () => (
  <ReferenceInput source="group.id" reference="analyzis_groups">
    <SelectInput optionText="name" source="group" isRequired />
  </ReferenceInput>
);

export const DicomNodeServerFields = ({ isEdit }: { isEdit?: boolean }) => {
  const t = useTranslate();
  const editPasswordProps = isEdit
    ? {
        disabled: true,
        InputProps: {},
      }
    : {};
  return (
    <fieldset className="border px-4 border-stone-600">
      <legend className="text-lg p-2">
        {t("resources.dicom_nodes.fieldGroup.server")}
      </legend>
      <div className="flex gap-4">
        <InputGuesser
          source="id"
          disabled
          label={`Id${!isEdit ? " (" + t("ra.generated") + ")" : ""}`}
        />
        <PasswordInput
          source="serverPassword"
          inputProps={{ autocomplete: "one-time-code" }}
          isRequired
          {...editPasswordProps}
        />
      </div>
    </fieldset>
  );
};

export const DicomNodeClientFields = () => {
  const t = useTranslate();
  return (
    <fieldset className="border px-4 border-stone-600">
      <legend className="text-lg p-2">
        {t("resources.dicom_nodes.fieldGroup.client")}
      </legend>
      <div className="flex gap-4">
        <TextInput
          source="username"
          inputProps={{ autocomplete: "one-time-code" }}
        />
        <PasswordInput
          source="clientPassword"
          inputProps={{ autocomplete: "one-time-code" }}
        />
      </div>
      <div className="flex gap-4">
        <InputGuesser source="url" />
        <InputGuesser source="aeTitle" />
      </div>
    </fieldset>
  );
};

export const DicomNodeOutputOptionFields = () => {
  const t = useTranslate();
  return (
    <fieldset className="border px-4 border-stone-600">
      <legend className="text-lg p-2">
        {t("resources.dicom_nodes.fieldGroup.output")}
      </legend>
      <div className="flex gap-4">
        <SelectInput
          source="report"
          choices={reportChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
        <SelectInput
          source="structuredData"
          choices={structuredDataChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
        <SelectInput
          source="mask"
          choices={maskChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
        <SelectInput
          source="mesh"
          choices={meshChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
        <SelectInput
          source="registeredVolume"
          choices={registeredVolumeChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
      </div>
      <div className="flex gap-4">
        <SelectInput
          source="reportCompression"
          choices={compressionChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
        <SelectInput
          source="registeredVolumeCompression"
          choices={compressionChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
        <SelectInput
          source="maskCompression"
          choices={compressionChoices}
          optionText="name"
          optionValue="value"
          emptyText="-- None --"
        />
      </div>
    </fieldset>
  );
};
